import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { providerInfoStyles } from './styles';

interface ProviderInfoSkeletonProps {
  type?: 'info' | 'card';
}
export const ProviderInfoSkeleton: React.FC<ProviderInfoSkeletonProps> = ({ type = 'card' }) => {
  return (
    <Box sx={providerInfoStyles.wrapper}>
      <Grid container spacing={2.5}>
        <Grid item sx={providerInfoStyles.imgWrapper}>
          <Skeleton
            variant="rectangular"
            sx={{
              width: { xs: '100%', sm: type === 'card' ? '15rem' : '20rem' },
            }}
            height="12.5rem"
          />
        </Grid>
        <Grid item xs={12} sm alignSelf="center">
          <Grid container spacing={2}>
            <Grid item xs>
              <Skeleton variant="text" width="12.5rem" />
              <Skeleton variant="rectangular" height="2rem" width="clamp(15rem, 20rem, 100%)" />
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2} alignItems="flex-start" direction={{ xs: 'column', md: 'row' }}>
              <Grid item xs>
                <Grid container spacing={0.25} direction="column">
                  {_.times(3, _.stubArray).map((_item, index) => (
                    <Grid key={index} item>
                      <Skeleton variant="text" width="clamp(12.5rem, 15rem, 100%)" />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
